import { DateField } from "../blocks/fields/DateField";
import { PicklistField } from "../blocks/fields/PicklistField";
import {
  DateRange,
  SingleDateRanges,
  dateRangeOptions,
  dateValueForCustom,
  dateValueForDay,
  dateValueForRange,
  getDateBounds,
  parseDay,
} from "./advancedSearchDates";
import { RuleDateValueProps } from "./RuleDateValue.types";

/** A date rule's value: a range to pick, and the day or days it needs. */
export function RuleDateValue({ rule, id, error, onChange }: RuleDateValueProps) {
  const { range, from, to } = getDateBounds(rule);
  const single = range !== null && SingleDateRanges.includes(range);
  const custom = range === DateRange.Custom;

  const changeRange = (value: string | null) =>
    onChange(dateValueForRange(rule, value ? Number(value) : null));

  return (
    <div className="row gx-3">
      <div className="col-12 col-md-5">
        <PicklistField
          label={rule.label}
          name={`${id}-range`}
          value={range}
          options={dateRangeOptions}
          onChange={changeRange}
          error={range ? undefined : error}
        />
      </div>
      {single && (
        <div className="col-12 col-md-4">
          <DateField
            label="Day"
            name={`${id}-day`}
            value={range === DateRange["On or Before"] ? to : from}
            onChange={(day) => onChange(dateValueForDay(rule, range, parseDay(day)))}
            error={error}
          />
        </div>
      )}
      {custom && (
        <>
          <div className="col-12 col-md-3">
            <DateField
              label="From"
              name={`${id}-from`}
              value={from}
              onChange={(day) => onChange(dateValueForCustom(rule, "From", parseDay(day)))}
              error={error}
            />
          </div>
          <div className="col-12 col-md-3">
            <DateField
              label="To"
              name={`${id}-to`}
              value={to}
              min={from ?? undefined}
              onChange={(day) => onChange(dateValueForCustom(rule, "To", parseDay(day)))}
            />
          </div>
        </>
      )}
    </div>
  );
}
